module.exports = __webpack_public_path__ + "img/Support-skill-625.f2c064d5.png";